import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { ArrowRight, History, Users } from "lucide-react";
import { CarryDialog } from "./CarryDialog";

const prevYear = (years, y) => [...years].sort().filter((x) => x < y).pop() || "";

const CarryLogs = ({ logs }) => (
  <div className="space-y-2" data-testid="carry-logs">
    <p className="text-sm font-semibold flex items-center gap-1.5"><History size={14} /> Registro dei passaggi</p>
    {logs.length === 0 ? <p className="text-xs text-muted-foreground">Nessun passaggio eseguito.</p> : (
      <ul className="divide-y divide-border rounded-lg border border-border text-xs">
        {logs.map((l) => (
          <li key={l.id} className="p-2 space-y-0.5" data-testid={`carry-log-${l.id}`}>
            <p><strong>{new Date(l.at).toLocaleString("it-IT")}</strong> · {l.from_year} → {l.to_year}</p>
            <p>Portati: <strong>{l.carried}</strong> · Saltati: <strong>{l.skipped_count}</strong>
              {Object.entries(l.skipped_reasons || {}).map(([r, n]) => <span key={r} className="text-muted-foreground"> · {r}: {n}</span>)}</p>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export const CarryStudentsCard = ({ years, currentYear, workYear, onDone }) => {
  const [from, setFrom] = useState(prevYear(years, workYear));
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const loadLogs = () => api.get("/admin/carry/logs").then((r) => setLogs(r.data)).catch(() => {});
  useEffect(() => { setFrom(prevYear(years, workYear)); }, [workYear, years]);
  useEffect(() => { loadLogs(); }, []);
  const sources = years.filter((y) => y !== workYear);

  return (
    <Card className="p-6 bg-card border-border space-y-4" data-testid="carry-card">
      <h3 className="text-xl flex items-center gap-2"><Users size={18} className="text-primary" /> Porta gli allievi nell'anno {workYear}</h3>
      <p className="text-sm text-muted-foreground">Gli allievi con un corso nell'anno di partenza (esclusi archiviati, docenti e master) ritrovano lo stesso corso nell'anno {workYear}, con tutto il resto da compilare. Resteranno "Da confermare" finché non inviano il modulo.</p>
      <div className="flex flex-wrap items-end gap-2">
        <div><Label className="text-xs">Anno di partenza</Label>
          <Select value={from} onValueChange={setFrom}>
            <SelectTrigger data-testid="carry-from-select" className="bg-white w-40 mt-1"><SelectValue placeholder="Scegli" /></SelectTrigger>
            <SelectContent>{sources.map((y) => <SelectItem key={y} value={y}>{y}{y === currentYear ? " (corrente)" : ""}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <ArrowRight size={16} className="mb-2.5 text-muted-foreground" />
        <div><Label className="text-xs">Anno di arrivo</Label>
          <p className="h-10 mt-1 px-3 flex items-center rounded-md border border-border text-sm" data-testid="carry-to-year">{workYear}{workYear === currentYear ? " (corrente)" : ""}</p>
        </div>
        <Button data-testid="carry-open-btn" disabled={!from} onClick={() => setOpen(true)}>Anteprima</Button>
      </div>
      <CarryLogs logs={logs} />
      <CarryDialog open={open} onOpenChange={setOpen} fromYear={from} toYear={workYear}
        onDone={(d) => { loadLogs(); onDone(d); }} />
    </Card>
  );
};
